import { axiosClient } from "./axiosClient";
import { ACCOUNT_ENDPOINTS } from "./endpoints";

import {
    AccountDiscoveryRequest,
    AccountDiscoveryResponse,
    LinkAccountRequest,
    LinkAccountResponse,
    LinkDescRequest,
    GetIdentifierRequest,
    GetIdentifierResponse,
    LinkStatusRequest,
} from "./api.types";

export const discoverAccounts = async (payload: AccountDiscoveryRequest): Promise<AccountDiscoveryResponse> => {
    const res = await axiosClient.post<AccountDiscoveryResponse>(
        ACCOUNT_ENDPOINTS.DISCOVER,
        payload
    );
    return res.data;
};

export const linkAccount = async (payload: LinkAccountRequest): Promise<LinkAccountResponse> => {
    const res = await axiosClient.post<LinkAccountResponse>(
        ACCOUNT_ENDPOINTS.LINK,
        payload
    );
    return res.data;
};

export const verifyLinkAccount = async (payload: LinkDescRequest): Promise<any> => {
    const res = await axiosClient.post<any>(
        ACCOUNT_ENDPOINTS.VERIFY_LINK,
        payload
    );
    return res.data;
};

export const getIdentifiersType = async (payload: GetIdentifierRequest): Promise<GetIdentifierResponse> => {
    const res = await axiosClient.post<GetIdentifierResponse>(
        ACCOUNT_ENDPOINTS.GET_IDENTIFIERS,
        payload
    );
    return res.data;
};

export const checkLinkStatus = async (payload: LinkStatusRequest): Promise<any> => {
    const res = await axiosClient.post<any>(
        ACCOUNT_ENDPOINTS.LINK_STATUS,
        payload
    );
    return res.data;
};
